import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LOCATION_ERROR, LocationService } from '@shared/services/location.service';
import { ContactTracingService } from '../../contact-tracing/services/contact-tracing.service';
import { LayoutService } from '@shared/services/layout.service';
import { QrCodeService } from '@shared/services/qr-code.service';

@Injectable({
  providedIn: 'root'
})
export class LocationCheckGuard implements CanActivate  {

  constructor(private locationService: LocationService,
              private contactTracingService: ContactTracingService,
              private layoutService: LayoutService,
              private router: Router,
              private qrCodeService: QrCodeService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.layoutService.currentConfig.locationCheck.active) {
      return true;
    } else {

      const parsedQrCode = this.qrCodeService.parsedQrCode;

      if (!parsedQrCode) {
        return true;
      }

      const qrCodeLocationDto = {
        lat: +parsedQrCode.latitude,
        lng: +parsedQrCode.longitude
      };

      return new Promise((resolve, reject) => {
        if (parsedQrCode) {
          this.locationService.checkLocation(qrCodeLocationDto)
            .then((res) => {
              switch (res) {
                case LOCATION_ERROR.ACCESS:
                  resolve(false);
                  this.router.navigate(['/location/access']);
                  break;
                case LOCATION_ERROR.DISTANCE:
                  resolve(false);
                  this.router.navigate(['/location/distance']);
                  break;
                default:
                  resolve(true);
                  break;
              }
            })
            .catch(err => {
              resolve(true);
            });
        }
      });
    }
  }
}
